import React from "react";
import { observer } from "mobx-react-lite";
import { useStore } from "../stores/Stores";
import { Select } from "@fluentui/react-components";
import { BuildingMultipleRegular } from "@fluentui/react-icons";
import Loader from "../shared/loader/Loader";
import styles from "./customerMeetings.module.scss";
import { BusinessLine } from "../shared/types/BusinessLine";
import RetailOrPrivateMeetingForm from "./forms/RetailOrPrivateMeetingForm";
import CorporateMeetingForm from "./forms/CorporateMeetingForm";
import { FormActionType } from "./forms/FormActionType";
import { CustomerMeeting } from "./store/CustomerMeeting";
import { mapBusinessLineToName } from "./MeetingHelpers";
import { useTranslation } from "../shared/translation/Translation";

interface UpdateMeetingProps {
    meeting: CustomerMeeting;

    onClose: () => void;
    onSuccess: () => void;
}

const UpdateMeeting: React.FC<UpdateMeetingProps> = observer((props: UpdateMeetingProps) => {
    const { meetingStore } = useStore();
    const messages = useTranslation();

    function renderForm(businessLine: BusinessLine) {
        switch (businessLine) {
            case BusinessLine.Private:
            case BusinessLine.Retail:
                return (
                    <RetailOrPrivateMeetingForm
                        formActionType={FormActionType.UpdateMeeting}
                        businessLine={props.meeting.businessLine}
                        meeting={props.meeting}
                        onClose={props.onClose}
                        onSuccess={props.onSuccess}
                    />
                );
            case BusinessLine.Corporate:
                return (
                    <CorporateMeetingForm
                        formActionType={FormActionType.UpdateMeeting}
                        businessLine={props.meeting.businessLine}
                        meeting={props.meeting}
                        onClose={props.onClose}
                        onSuccess={props.onSuccess}
                    />
                );
        }
    }

    function renderContent() {
        if (meetingStore.updateMeetingRequestStatus.isPending) {
            return <Loader text={messages.updateMeeting.updating} />;
        }

        return (
            <>
                <div className={styles.businessLineDropdownWrapper}>
                    <BuildingMultipleRegular className={styles.businessLineIcon} style={{ fontSize: "24px" }} />
                    <Select
                        className={styles.businessLineDropdown}
                        disabled
                        value={mapBusinessLineToName(messages, props.meeting.businessLine)}
                    >
                        <option value={mapBusinessLineToName(messages, props.meeting.businessLine)}>
                            {mapBusinessLineToName(messages, props.meeting.businessLine)}
                        </option>
                    </Select>
                </div>
                {renderForm(props.meeting.businessLine)}
            </>
        );
    }

    return <div className={styles.modalWrapper}>{renderContent()}</div>;
});

export default UpdateMeeting;
